/**
 * @file: 抽奖地址页
 * @author: wence
 */
import React, {PureComponent} from 'react';
import cn from 'classnames';
import FromModal from './modal';
import {fetchPrizeInfo, fetchActivityInfo} from '../../actions/activityAction';

import {flag, confirm} from './index';
import './index.less';

export default class ActivityAddress extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            prizeList: [],
            visible: false,
            banAddress: false,
            prizeInfo: null,
            activityInfo: {},
            conMinHeight: 0
        };

        if (this.isPC()) {
            location.href = '/activity/address';
        }
    }

    async componentDidMount() {
        const footer = document.querySelector('.footer-bar');
        this.setState({
            conMinHeight: window.innerHeight - footer.offsetHeight
        });

        await this.fetchActivityInfo();
        await this.fetchPrizeInfo();
    }

    getActivityId = () => {
        return ((this.state.activityInfo || {}).activity || {}).activity_id;
    };

    fetchPrizeInfo = async () => {
        const res = await fetchPrizeInfo({aid: this.getActivityId(), flag});

        if (res.status === 0) {
            this.setState({
                banAddress: res.data.ban,
                prizeList: res.data.info
            });

            if (res.data && res.data.length <= 0) {
                this.confirm = confirm({
                    title: '',
                    content: '这里空空哦～快去抽奖吧',
                    okText: '返回抽奖',
                    okClick: () => {
                        this.confirm && this.confirm();
                        window.location.href = '/m/activity/prize';
                    }
                });
            }
        }
        else if (res.status === 401) {
            this.confirm = confirm({
                title: '',
                content: res.description,
                okText: '去登录',
                okClick: () => {
                    this.confirm && this.confirm();
                    window.location.href = this.loginUrl();
                }
            });
        }
    };

    fetchActivityInfo = async () => {
        const res = await fetchActivityInfo({flag, 'is_wap': 1});

        if (res.status === 0) {
            this.setState({activityInfo: res.data});
        }
        else {
            this.setState({activityInfo: {}});
        }
    };

    render() {
        const {prizeList, banAddress} = this.state;
        return (
            <div style={{minHeight: this.state.conMinHeight}} className="w-activity w-activity-address-content">
                {prizeList && prizeList.length > 0
                    ? <div>
                        <FromModal
                            aid={this.getActivityId()}
                            resetData={() => this.fetchPrizeInfo()}
                            visible={this.state.visible}
                            successMsg={'信息提交成功'}
                            parizeInfo={this.state.prizeInfo}
                            onCancel={() => this.setState({visible: false, parizeInfo: null})}/>
                        <div className="w-activity-banner"></div>
                        <div className="w-section-title padding-top-100">
                            <h3 className="w-section-title-text">我的奖品</h3>
                        </div>
                        <div className="w-activity-address">
                            {
                                prizeList.map((prizeInfo, index) => {
                                    const hasBtn = prizeInfo.prize_type === 1;

                                    return (
                                        <div
                                            key={index}
                                            className={cn(
                                                'w-activity-address-item-wrapper',
                                                {
                                                    'has-btn':
                                                        (prizeInfo.prize_type !== 1 || (hasBtn && !prizeInfo.address))
                                                }
                                            )}>
                                            <div className="w-activity-address-item">
                                                <p>
                                                    <span>编号：</span>
                                                    <span>{index + 1}</span>
                                                </p>
                                                <p>
                                                    <span>时间：</span>
                                                    <span>{prizeInfo.prize_time}</span>
                                                </p>
                                                <p>
                                                    <span>奖品名称：</span>
                                                    <span>{prizeInfo.prize_name}</span>
                                                </p>
                                                <p className="address">
                                                    <span>地址信息：</span>
                                                    <span>{prizeInfo.address || '-'}</span>
                                                </p>
                                                {hasBtn && !prizeInfo.address
                                                    ? banAddress
                                                        ? <div
                                                            onClick={() => {
                                                                if (prizeInfo.prize_type === 1) {
                                                                    this.setState({prizeInfo, visible: true});
                                                                }
                                                            }}
                                                            className="product-btn w-address-btn">
                                                            填写地址
                                                        </div>
                                                        : <div
                                                            className="product-btn  w-address-btn disabled">
                                                            已过期
                                                        </div>
                                                    : ''
                                                }
                                                {!hasBtn
                                                && <a
                                                    href={'/console/#/orderView'}
                                                    target={'_blank'}
                                                    className="product-btn w-address-btn">
                                                    前往控制台
                                                </a>
                                                }
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                    : (
                        <div style={{minHeight: this.state.conMinHeight}} className="w-activity-empty">
                            这里空空哦～快去抽奖吧
                        </div>
                    )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/activity/activityAddress.js